
import {serializable, alias, primitive} from 'serializr';

export class Company { 

	@serializable(alias('id', primitive()))
	id?: number;

	@serializable(alias('name', primitive()))
	name?: string;

	@serializable(alias('type', primitive()))
	type?: string;

	@serializable(alias('revenue_range', primitive()))
	revenueRange?: string;

	@serializable(alias('member', primitive()))
	member?: string;

	@serializable(alias('referral', primitive()))
	referral?: string;

	@serializable(alias('createdAt', primitive()))
	createdAt?: string;

	@serializable(alias('updatedAt', primitive()))
	updatedAt?: string;

	@serializable(alias('status', primitive()))
	status?: string;

	@serializable(alias('image', primitive()))
	image?: string;

	@serializable(alias('product_count', primitive()))
	productCount?: string;

	@serializable(alias('is_stewwi_customer', primitive()))
	isStewwiCustomer?: boolean;

}